/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as NoAccessRouteImport } from './routes/no-access'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppLeadsRouteImport } from './routes/_app/leads'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthSignInRouteImport } from './routes/_auth/sign-in'
import { Route as AppAccountSecurityRouteImport } from './routes/_app/account.security'
import { Route as AppAccountingIndexRouteImport } from './routes/_app/accounting.index'
import { Route as AppAccountingContactsRouteImport } from './routes/_app/accounting.contacts'
import { Route as AppAccountingProductsRouteImport } from './routes/_app/accounting.products'
import { Route as AppAccountingReportsRouteImport } from './routes/_app/accounting.reports'
import { Route as AppAccountingSettingsRouteImport } from './routes/_app/accounting.settings'
import { Route as AppPlatformIndexRouteImport } from './routes/_app/platform.index'
import { Route as AppPlatformAdsRouteImport } from './routes/_app/platform.ads'
import { Route as AppPlatformAiDemoRouteImport } from './routes/_app/platform.ai-demo'
import { Route as AppPlatformInvoicesRouteImport } from './routes/_app/platform.invoices'
import { Route as AppPlatformLeadsRouteImport } from './routes/_app/platform.leads'
import { Route as AppPlatformOnboardingRouteImport } from './routes/_app/platform.onboarding'
import { Route as AppPlatformPageInboxRouteImport } from './routes/_app/platform.page-inbox'
import { Route as AppPlatformPlansRouteImport } from './routes/_app/platform.plans'
import { Route as AppPlatformRevenueRouteImport } from './routes/_app/platform.revenue'
import { Route as AppPlatformSalesRouteImport } from './routes/_app/platform.sales'
import { Route as AppPlatformSupportCasesRouteImport } from './routes/_app/platform.support-cases'
import { Route as AppPlatformTeamRouteImport } from './routes/_app/platform.team'
import { Route as AppPlatformUsageRouteImport } from './routes/_app/platform.usage'
import { Route as AppPlatformUsersRouteImport } from './routes/_app/platform.users'
import { Route as AppAccountingA4ShopIdRouteImport } from './routes/_app/accounting.a4-shop.$id'
import { Route as AppAccountingA4IdRouteImport } from './routes/_app/accounting.a4.$id'
import { Route as AppAccountingCreditNotesIndexRouteImport } from './routes/_app/accounting.credit-notes.index'
import { Route as AppAccountingCreditNotesIdRouteImport } from './routes/_app/accounting.credit-notes.$id'
import { Route as AppAccountingCreditNotesNewRouteImport } from './routes/_app/accounting.credit-notes.new'
import { Route as AppAccountingExpensesIndexRouteImport } from './routes/_app/accounting.expenses.index'
import { Route as AppAccountingExpensesIdRouteImport } from './routes/_app/accounting.expenses.$id'
import { Route as AppAccountingExpensesNewRouteImport } from './routes/_app/accounting.expenses.new'
import { Route as AppAccountingInvoicesIndexRouteImport } from './routes/_app/accounting.invoices.index'
import { Route as AppAccountingInvoicesIdRouteImport } from './routes/_app/accounting.invoices.$id'
import { Route as AppAccountingInvoicesNewRouteImport } from './routes/_app/accounting.invoices.new'
import { Route as AppAccountingQuotationsIndexRouteImport } from './routes/_app/accounting.quotations.index'
import { Route as AppAccountingQuotationsIdRouteImport } from './routes/_app/accounting.quotations.$id'
import { Route as AppAccountingQuotationsNewRouteImport } from './routes/_app/accounting.quotations.new'
import { Route as AppAccountingReceiptsIndexRouteImport } from './routes/_app/accounting.receipts.index'
import { Route as AppAccountingReceiptsIdRouteImport } from './routes/_app/accounting.receipts.$id'
import { Route as AppAccountingReceiptsNewRouteImport } from './routes/_app/accounting.receipts.new'
import { Route as AppPlatformA4IdRouteImport } from './routes/_app/platform.a4.$id'
import { Route as AppPlatformAuditsIndexRouteImport } from './routes/_app/platform.audits.index'
import { Route as AppPlatformAuditsIdRouteImport } from './routes/_app/platform.audits.$id'
import { Route as AppPlatformEngagementsIndexRouteImport } from './routes/_app/platform.engagements.index'
import { Route as AppPlatformEngagementsIdRouteImport } from './routes/_app/platform.engagements.$id'
import { Route as AppPlatformTenantsIndexRouteImport } from './routes/_app/platform.tenants.index'
import { Route as AppPlatformTenantsIdRouteImport } from './routes/_app/platform.tenants.$id'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const NoAccessRoute = NoAccessRouteImport.update({
  id: '/no-access',
  path: '/no-access',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppLeadsRoute = AppLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => AppRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRoute,
} as any)
const AppAccountSecurityRoute = AppAccountSecurityRouteImport.update({
  id: '/account/security',
  path: '/account/security',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingIndexRoute = AppAccountingIndexRouteImport.update({
  id: '/accounting/',
  path: '/accounting/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingContactsRoute = AppAccountingContactsRouteImport.update({
  id: '/accounting/contacts',
  path: '/accounting/contacts',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingProductsRoute = AppAccountingProductsRouteImport.update({
  id: '/accounting/products',
  path: '/accounting/products',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingReportsRoute = AppAccountingReportsRouteImport.update({
  id: '/accounting/reports',
  path: '/accounting/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingSettingsRoute = AppAccountingSettingsRouteImport.update({
  id: '/accounting/settings',
  path: '/accounting/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformIndexRoute = AppPlatformIndexRouteImport.update({
  id: '/platform/',
  path: '/platform/',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformAdsRoute = AppPlatformAdsRouteImport.update({
  id: '/platform/ads',
  path: '/platform/ads',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformAiDemoRoute = AppPlatformAiDemoRouteImport.update({
  id: '/platform/ai-demo',
  path: '/platform/ai-demo',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformInvoicesRoute = AppPlatformInvoicesRouteImport.update({
  id: '/platform/invoices',
  path: '/platform/invoices',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformLeadsRoute = AppPlatformLeadsRouteImport.update({
  id: '/platform/leads',
  path: '/platform/leads',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformOnboardingRoute = AppPlatformOnboardingRouteImport.update({
  id: '/platform/onboarding',
  path: '/platform/onboarding',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformPageInboxRoute = AppPlatformPageInboxRouteImport.update({
  id: '/platform/page-inbox',
  path: '/platform/page-inbox',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformPlansRoute = AppPlatformPlansRouteImport.update({
  id: '/platform/plans',
  path: '/platform/plans',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformRevenueRoute = AppPlatformRevenueRouteImport.update({
  id: '/platform/revenue',
  path: '/platform/revenue',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformSalesRoute = AppPlatformSalesRouteImport.update({
  id: '/platform/sales',
  path: '/platform/sales',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformSupportCasesRoute = AppPlatformSupportCasesRouteImport.update({
  id: '/platform/support-cases',
  path: '/platform/support-cases',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformTeamRoute = AppPlatformTeamRouteImport.update({
  id: '/platform/team',
  path: '/platform/team',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformUsageRoute = AppPlatformUsageRouteImport.update({
  id: '/platform/usage',
  path: '/platform/usage',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformUsersRoute = AppPlatformUsersRouteImport.update({
  id: '/platform/users',
  path: '/platform/users',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingA4ShopIdRoute = AppAccountingA4ShopIdRouteImport.update({
  id: '/accounting/a4-shop/$id',
  path: '/accounting/a4-shop/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingA4IdRoute = AppAccountingA4IdRouteImport.update({
  id: '/accounting/a4/$id',
  path: '/accounting/a4/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingCreditNotesIndexRoute =
  AppAccountingCreditNotesIndexRouteImport.update({
    id: '/accounting/credit-notes/',
    path: '/accounting/credit-notes/',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccountingCreditNotesIdRoute =
  AppAccountingCreditNotesIdRouteImport.update({
    id: '/accounting/credit-notes/$id',
    path: '/accounting/credit-notes/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccountingCreditNotesNewRoute =
  AppAccountingCreditNotesNewRouteImport.update({
    id: '/accounting/credit-notes/new',
    path: '/accounting/credit-notes/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccountingExpensesIndexRoute =
  AppAccountingExpensesIndexRouteImport.update({
    id: '/accounting/expenses/',
    path: '/accounting/expenses/',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccountingExpensesIdRoute = AppAccountingExpensesIdRouteImport.update({
  id: '/accounting/expenses/$id',
  path: '/accounting/expenses/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingExpensesNewRoute =
  AppAccountingExpensesNewRouteImport.update({
    id: '/accounting/expenses/new',
    path: '/accounting/expenses/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccountingInvoicesIndexRoute =
  AppAccountingInvoicesIndexRouteImport.update({
    id: '/accounting/invoices/',
    path: '/accounting/invoices/',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccountingInvoicesIdRoute = AppAccountingInvoicesIdRouteImport.update({
  id: '/accounting/invoices/$id',
  path: '/accounting/invoices/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingInvoicesNewRoute =
  AppAccountingInvoicesNewRouteImport.update({
    id: '/accounting/invoices/new',
    path: '/accounting/invoices/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccountingQuotationsIndexRoute =
  AppAccountingQuotationsIndexRouteImport.update({
    id: '/accounting/quotations/',
    path: '/accounting/quotations/',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccountingQuotationsIdRoute =
  AppAccountingQuotationsIdRouteImport.update({
    id: '/accounting/quotations/$id',
    path: '/accounting/quotations/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccountingQuotationsNewRoute =
  AppAccountingQuotationsNewRouteImport.update({
    id: '/accounting/quotations/new',
    path: '/accounting/quotations/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccountingReceiptsIndexRoute =
  AppAccountingReceiptsIndexRouteImport.update({
    id: '/accounting/receipts/',
    path: '/accounting/receipts/',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccountingReceiptsIdRoute = AppAccountingReceiptsIdRouteImport.update({
  id: '/accounting/receipts/$id',
  path: '/accounting/receipts/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingReceiptsNewRoute =
  AppAccountingReceiptsNewRouteImport.update({
    id: '/accounting/receipts/new',
    path: '/accounting/receipts/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppPlatformA4IdRoute = AppPlatformA4IdRouteImport.update({
  id: '/platform/a4/$id',
  path: '/platform/a4/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformAuditsIndexRoute = AppPlatformAuditsIndexRouteImport.update({
  id: '/platform/audits/',
  path: '/platform/audits/',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformAuditsIdRoute = AppPlatformAuditsIdRouteImport.update({
  id: '/platform/audits/$id',
  path: '/platform/audits/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformEngagementsIndexRoute =
  AppPlatformEngagementsIndexRouteImport.update({
    id: '/platform/engagements/',
    path: '/platform/engagements/',
    getParentRoute: () => AppRoute,
  } as any)
const AppPlatformEngagementsIdRoute =
  AppPlatformEngagementsIdRouteImport.update({
    id: '/platform/engagements/$id',
    path: '/platform/engagements/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppPlatformTenantsIndexRoute = AppPlatformTenantsIndexRouteImport.update({
  id: '/platform/tenants/',
  path: '/platform/tenants/',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformTenantsIdRoute = AppPlatformTenantsIdRouteImport.update({
  id: '/platform/tenants/$id',
  path: '/platform/tenants/$id',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/no-access': typeof NoAccessRoute
  '/leads': typeof AppLeadsRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/account/security': typeof AppAccountSecurityRoute
  '/accounting/contacts': typeof AppAccountingContactsRoute
  '/accounting/products': typeof AppAccountingProductsRoute
  '/accounting/reports': typeof AppAccountingReportsRoute
  '/accounting/settings': typeof AppAccountingSettingsRoute
  '/platform/ads': typeof AppPlatformAdsRoute
  '/platform/ai-demo': typeof AppPlatformAiDemoRoute
  '/platform/invoices': typeof AppPlatformInvoicesRoute
  '/platform/leads': typeof AppPlatformLeadsRoute
  '/platform/onboarding': typeof AppPlatformOnboardingRoute
  '/platform/page-inbox': typeof AppPlatformPageInboxRoute
  '/platform/plans': typeof AppPlatformPlansRoute
  '/platform/revenue': typeof AppPlatformRevenueRoute
  '/platform/sales': typeof AppPlatformSalesRoute
  '/platform/support-cases': typeof AppPlatformSupportCasesRoute
  '/platform/team': typeof AppPlatformTeamRoute
  '/platform/usage': typeof AppPlatformUsageRoute
  '/platform/users': typeof AppPlatformUsersRoute
  '/accounting/': typeof AppAccountingIndexRoute
  '/platform/': typeof AppPlatformIndexRoute
  '/accounting/a4-shop/$id': typeof AppAccountingA4ShopIdRoute
  '/accounting/a4/$id': typeof AppAccountingA4IdRoute
  '/accounting/credit-notes/$id': typeof AppAccountingCreditNotesIdRoute
  '/accounting/credit-notes/new': typeof AppAccountingCreditNotesNewRoute
  '/accounting/expenses/$id': typeof AppAccountingExpensesIdRoute
  '/accounting/expenses/new': typeof AppAccountingExpensesNewRoute
  '/accounting/invoices/$id': typeof AppAccountingInvoicesIdRoute
  '/accounting/invoices/new': typeof AppAccountingInvoicesNewRoute
  '/accounting/quotations/$id': typeof AppAccountingQuotationsIdRoute
  '/accounting/quotations/new': typeof AppAccountingQuotationsNewRoute
  '/accounting/receipts/$id': typeof AppAccountingReceiptsIdRoute
  '/accounting/receipts/new': typeof AppAccountingReceiptsNewRoute
  '/platform/a4/$id': typeof AppPlatformA4IdRoute
  '/platform/audits/$id': typeof AppPlatformAuditsIdRoute
  '/platform/engagements/$id': typeof AppPlatformEngagementsIdRoute
  '/platform/tenants/$id': typeof AppPlatformTenantsIdRoute
  '/accounting/credit-notes/': typeof AppAccountingCreditNotesIndexRoute
  '/accounting/expenses/': typeof AppAccountingExpensesIndexRoute
  '/accounting/invoices/': typeof AppAccountingInvoicesIndexRoute
  '/accounting/quotations/': typeof AppAccountingQuotationsIndexRoute
  '/accounting/receipts/': typeof AppAccountingReceiptsIndexRoute
  '/platform/audits/': typeof AppPlatformAuditsIndexRoute
  '/platform/engagements/': typeof AppPlatformEngagementsIndexRoute
  '/platform/tenants/': typeof AppPlatformTenantsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/no-access': typeof NoAccessRoute
  '/leads': typeof AppLeadsRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/account/security': typeof AppAccountSecurityRoute
  '/accounting/contacts': typeof AppAccountingContactsRoute
  '/accounting/products': typeof AppAccountingProductsRoute
  '/accounting/reports': typeof AppAccountingReportsRoute
  '/accounting/settings': typeof AppAccountingSettingsRoute
  '/platform/ads': typeof AppPlatformAdsRoute
  '/platform/ai-demo': typeof AppPlatformAiDemoRoute
  '/platform/invoices': typeof AppPlatformInvoicesRoute
  '/platform/leads': typeof AppPlatformLeadsRoute
  '/platform/onboarding': typeof AppPlatformOnboardingRoute
  '/platform/page-inbox': typeof AppPlatformPageInboxRoute
  '/platform/plans': typeof AppPlatformPlansRoute
  '/platform/revenue': typeof AppPlatformRevenueRoute
  '/platform/sales': typeof AppPlatformSalesRoute
  '/platform/support-cases': typeof AppPlatformSupportCasesRoute
  '/platform/team': typeof AppPlatformTeamRoute
  '/platform/usage': typeof AppPlatformUsageRoute
  '/platform/users': typeof AppPlatformUsersRoute
  '/accounting': typeof AppAccountingIndexRoute
  '/platform': typeof AppPlatformIndexRoute
  '/accounting/a4-shop/$id': typeof AppAccountingA4ShopIdRoute
  '/accounting/a4/$id': typeof AppAccountingA4IdRoute
  '/accounting/credit-notes/$id': typeof AppAccountingCreditNotesIdRoute
  '/accounting/credit-notes/new': typeof AppAccountingCreditNotesNewRoute
  '/accounting/expenses/$id': typeof AppAccountingExpensesIdRoute
  '/accounting/expenses/new': typeof AppAccountingExpensesNewRoute
  '/accounting/invoices/$id': typeof AppAccountingInvoicesIdRoute
  '/accounting/invoices/new': typeof AppAccountingInvoicesNewRoute
  '/accounting/quotations/$id': typeof AppAccountingQuotationsIdRoute
  '/accounting/quotations/new': typeof AppAccountingQuotationsNewRoute
  '/accounting/receipts/$id': typeof AppAccountingReceiptsIdRoute
  '/accounting/receipts/new': typeof AppAccountingReceiptsNewRoute
  '/platform/a4/$id': typeof AppPlatformA4IdRoute
  '/platform/audits/$id': typeof AppPlatformAuditsIdRoute
  '/platform/engagements/$id': typeof AppPlatformEngagementsIdRoute
  '/platform/tenants/$id': typeof AppPlatformTenantsIdRoute
  '/accounting/credit-notes': typeof AppAccountingCreditNotesIndexRoute
  '/accounting/expenses': typeof AppAccountingExpensesIndexRoute
  '/accounting/invoices': typeof AppAccountingInvoicesIndexRoute
  '/accounting/quotations': typeof AppAccountingQuotationsIndexRoute
  '/accounting/receipts': typeof AppAccountingReceiptsIndexRoute
  '/platform/audits': typeof AppPlatformAuditsIndexRoute
  '/platform/engagements': typeof AppPlatformEngagementsIndexRoute
  '/platform/tenants': typeof AppPlatformTenantsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/no-access': typeof NoAccessRoute
  '/_app/leads': typeof AppLeadsRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/sign-in': typeof AuthSignInRoute
  '/_app/': typeof AppIndexRoute
  '/_app/account/security': typeof AppAccountSecurityRoute
  '/_app/accounting/contacts': typeof AppAccountingContactsRoute
  '/_app/accounting/products': typeof AppAccountingProductsRoute
  '/_app/accounting/reports': typeof AppAccountingReportsRoute
  '/_app/accounting/settings': typeof AppAccountingSettingsRoute
  '/_app/platform/ads': typeof AppPlatformAdsRoute
  '/_app/platform/ai-demo': typeof AppPlatformAiDemoRoute
  '/_app/platform/invoices': typeof AppPlatformInvoicesRoute
  '/_app/platform/leads': typeof AppPlatformLeadsRoute
  '/_app/platform/onboarding': typeof AppPlatformOnboardingRoute
  '/_app/platform/page-inbox': typeof AppPlatformPageInboxRoute
  '/_app/platform/plans': typeof AppPlatformPlansRoute
  '/_app/platform/revenue': typeof AppPlatformRevenueRoute
  '/_app/platform/sales': typeof AppPlatformSalesRoute
  '/_app/platform/support-cases': typeof AppPlatformSupportCasesRoute
  '/_app/platform/team': typeof AppPlatformTeamRoute
  '/_app/platform/usage': typeof AppPlatformUsageRoute
  '/_app/platform/users': typeof AppPlatformUsersRoute
  '/_app/accounting/': typeof AppAccountingIndexRoute
  '/_app/platform/': typeof AppPlatformIndexRoute
  '/_app/accounting/a4-shop/$id': typeof AppAccountingA4ShopIdRoute
  '/_app/accounting/a4/$id': typeof AppAccountingA4IdRoute
  '/_app/accounting/credit-notes/$id': typeof AppAccountingCreditNotesIdRoute
  '/_app/accounting/credit-notes/new': typeof AppAccountingCreditNotesNewRoute
  '/_app/accounting/expenses/$id': typeof AppAccountingExpensesIdRoute
  '/_app/accounting/expenses/new': typeof AppAccountingExpensesNewRoute
  '/_app/accounting/invoices/$id': typeof AppAccountingInvoicesIdRoute
  '/_app/accounting/invoices/new': typeof AppAccountingInvoicesNewRoute
  '/_app/accounting/quotations/$id': typeof AppAccountingQuotationsIdRoute
  '/_app/accounting/quotations/new': typeof AppAccountingQuotationsNewRoute
  '/_app/accounting/receipts/$id': typeof AppAccountingReceiptsIdRoute
  '/_app/accounting/receipts/new': typeof AppAccountingReceiptsNewRoute
  '/_app/platform/a4/$id': typeof AppPlatformA4IdRoute
  '/_app/platform/audits/$id': typeof AppPlatformAuditsIdRoute
  '/_app/platform/engagements/$id': typeof AppPlatformEngagementsIdRoute
  '/_app/platform/tenants/$id': typeof AppPlatformTenantsIdRoute
  '/_app/accounting/credit-notes/': typeof AppAccountingCreditNotesIndexRoute
  '/_app/accounting/expenses/': typeof AppAccountingExpensesIndexRoute
  '/_app/accounting/invoices/': typeof AppAccountingInvoicesIndexRoute
  '/_app/accounting/quotations/': typeof AppAccountingQuotationsIndexRoute
  '/_app/accounting/receipts/': typeof AppAccountingReceiptsIndexRoute
  '/_app/platform/audits/': typeof AppPlatformAuditsIndexRoute
  '/_app/platform/engagements/': typeof AppPlatformEngagementsIndexRoute
  '/_app/platform/tenants/': typeof AppPlatformTenantsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/no-access'
    | '/leads'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/account/security'
    | '/accounting/contacts'
    | '/accounting/products'
    | '/accounting/reports'
    | '/accounting/settings'
    | '/platform/ads'
    | '/platform/ai-demo'
    | '/platform/invoices'
    | '/platform/leads'
    | '/platform/onboarding'
    | '/platform/page-inbox'
    | '/platform/plans'
    | '/platform/revenue'
    | '/platform/sales'
    | '/platform/support-cases'
    | '/platform/team'
    | '/platform/usage'
    | '/platform/users'
    | '/accounting/'
    | '/platform/'
    | '/accounting/a4-shop/$id'
    | '/accounting/a4/$id'
    | '/accounting/credit-notes/$id'
    | '/accounting/credit-notes/new'
    | '/accounting/expenses/$id'
    | '/accounting/expenses/new'
    | '/accounting/invoices/$id'
    | '/accounting/invoices/new'
    | '/accounting/quotations/$id'
    | '/accounting/quotations/new'
    | '/accounting/receipts/$id'
    | '/accounting/receipts/new'
    | '/platform/a4/$id'
    | '/platform/audits/$id'
    | '/platform/engagements/$id'
    | '/platform/tenants/$id'
    | '/accounting/credit-notes/'
    | '/accounting/expenses/'
    | '/accounting/invoices/'
    | '/accounting/quotations/'
    | '/accounting/receipts/'
    | '/platform/audits/'
    | '/platform/engagements/'
    | '/platform/tenants/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/no-access'
    | '/leads'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/account/security'
    | '/accounting/contacts'
    | '/accounting/products'
    | '/accounting/reports'
    | '/accounting/settings'
    | '/platform/ads'
    | '/platform/ai-demo'
    | '/platform/invoices'
    | '/platform/leads'
    | '/platform/onboarding'
    | '/platform/page-inbox'
    | '/platform/plans'
    | '/platform/revenue'
    | '/platform/sales'
    | '/platform/support-cases'
    | '/platform/team'
    | '/platform/usage'
    | '/platform/users'
    | '/accounting'
    | '/platform'
    | '/accounting/a4-shop/$id'
    | '/accounting/a4/$id'
    | '/accounting/credit-notes/$id'
    | '/accounting/credit-notes/new'
    | '/accounting/expenses/$id'
    | '/accounting/expenses/new'
    | '/accounting/invoices/$id'
    | '/accounting/invoices/new'
    | '/accounting/quotations/$id'
    | '/accounting/quotations/new'
    | '/accounting/receipts/$id'
    | '/accounting/receipts/new'
    | '/platform/a4/$id'
    | '/platform/audits/$id'
    | '/platform/engagements/$id'
    | '/platform/tenants/$id'
    | '/accounting/credit-notes'
    | '/accounting/expenses'
    | '/accounting/invoices'
    | '/accounting/quotations'
    | '/accounting/receipts'
    | '/platform/audits'
    | '/platform/engagements'
    | '/platform/tenants'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/no-access'
    | '/_app/leads'
    | '/_auth/forgot-password'
    | '/_auth/reset-password'
    | '/_auth/sign-in'
    | '/_app/'
    | '/_app/account/security'
    | '/_app/accounting/contacts'
    | '/_app/accounting/products'
    | '/_app/accounting/reports'
    | '/_app/accounting/settings'
    | '/_app/platform/ads'
    | '/_app/platform/ai-demo'
    | '/_app/platform/invoices'
    | '/_app/platform/leads'
    | '/_app/platform/onboarding'
    | '/_app/platform/page-inbox'
    | '/_app/platform/plans'
    | '/_app/platform/revenue'
    | '/_app/platform/sales'
    | '/_app/platform/support-cases'
    | '/_app/platform/team'
    | '/_app/platform/usage'
    | '/_app/platform/users'
    | '/_app/accounting/'
    | '/_app/platform/'
    | '/_app/accounting/a4-shop/$id'
    | '/_app/accounting/a4/$id'
    | '/_app/accounting/credit-notes/$id'
    | '/_app/accounting/credit-notes/new'
    | '/_app/accounting/expenses/$id'
    | '/_app/accounting/expenses/new'
    | '/_app/accounting/invoices/$id'
    | '/_app/accounting/invoices/new'
    | '/_app/accounting/quotations/$id'
    | '/_app/accounting/quotations/new'
    | '/_app/accounting/receipts/$id'
    | '/_app/accounting/receipts/new'
    | '/_app/platform/a4/$id'
    | '/_app/platform/audits/$id'
    | '/_app/platform/engagements/$id'
    | '/_app/platform/tenants/$id'
    | '/_app/accounting/credit-notes/'
    | '/_app/accounting/expenses/'
    | '/_app/accounting/invoices/'
    | '/_app/accounting/quotations/'
    | '/_app/accounting/receipts/'
    | '/_app/platform/audits/'
    | '/_app/platform/engagements/'
    | '/_app/platform/tenants/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  NoAccessRoute: typeof NoAccessRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/no-access': {
      id: '/no-access'
      path: '/no-access'
      fullPath: '/no-access'
      preLoaderRoute: typeof NoAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leads': {
      id: '/_app/leads'
      path: '/leads'
      fullPath: '/leads'
      preLoaderRoute: typeof AppLeadsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/account/security': {
      id: '/_app/account/security'
      path: '/account/security'
      fullPath: '/account/security'
      preLoaderRoute: typeof AppAccountSecurityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/': {
      id: '/_app/accounting/'
      path: '/accounting'
      fullPath: '/accounting/'
      preLoaderRoute: typeof AppAccountingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/contacts': {
      id: '/_app/accounting/contacts'
      path: '/accounting/contacts'
      fullPath: '/accounting/contacts'
      preLoaderRoute: typeof AppAccountingContactsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/products': {
      id: '/_app/accounting/products'
      path: '/accounting/products'
      fullPath: '/accounting/products'
      preLoaderRoute: typeof AppAccountingProductsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/reports': {
      id: '/_app/accounting/reports'
      path: '/accounting/reports'
      fullPath: '/accounting/reports'
      preLoaderRoute: typeof AppAccountingReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/settings': {
      id: '/_app/accounting/settings'
      path: '/accounting/settings'
      fullPath: '/accounting/settings'
      preLoaderRoute: typeof AppAccountingSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/': {
      id: '/_app/platform/'
      path: '/platform'
      fullPath: '/platform/'
      preLoaderRoute: typeof AppPlatformIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/ads': {
      id: '/_app/platform/ads'
      path: '/platform/ads'
      fullPath: '/platform/ads'
      preLoaderRoute: typeof AppPlatformAdsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/ai-demo': {
      id: '/_app/platform/ai-demo'
      path: '/platform/ai-demo'
      fullPath: '/platform/ai-demo'
      preLoaderRoute: typeof AppPlatformAiDemoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/invoices': {
      id: '/_app/platform/invoices'
      path: '/platform/invoices'
      fullPath: '/platform/invoices'
      preLoaderRoute: typeof AppPlatformInvoicesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/leads': {
      id: '/_app/platform/leads'
      path: '/platform/leads'
      fullPath: '/platform/leads'
      preLoaderRoute: typeof AppPlatformLeadsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/onboarding': {
      id: '/_app/platform/onboarding'
      path: '/platform/onboarding'
      fullPath: '/platform/onboarding'
      preLoaderRoute: typeof AppPlatformOnboardingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/page-inbox': {
      id: '/_app/platform/page-inbox'
      path: '/platform/page-inbox'
      fullPath: '/platform/page-inbox'
      preLoaderRoute: typeof AppPlatformPageInboxRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/plans': {
      id: '/_app/platform/plans'
      path: '/platform/plans'
      fullPath: '/platform/plans'
      preLoaderRoute: typeof AppPlatformPlansRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/revenue': {
      id: '/_app/platform/revenue'
      path: '/platform/revenue'
      fullPath: '/platform/revenue'
      preLoaderRoute: typeof AppPlatformRevenueRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/sales': {
      id: '/_app/platform/sales'
      path: '/platform/sales'
      fullPath: '/platform/sales'
      preLoaderRoute: typeof AppPlatformSalesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/support-cases': {
      id: '/_app/platform/support-cases'
      path: '/platform/support-cases'
      fullPath: '/platform/support-cases'
      preLoaderRoute: typeof AppPlatformSupportCasesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/team': {
      id: '/_app/platform/team'
      path: '/platform/team'
      fullPath: '/platform/team'
      preLoaderRoute: typeof AppPlatformTeamRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/usage': {
      id: '/_app/platform/usage'
      path: '/platform/usage'
      fullPath: '/platform/usage'
      preLoaderRoute: typeof AppPlatformUsageRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/users': {
      id: '/_app/platform/users'
      path: '/platform/users'
      fullPath: '/platform/users'
      preLoaderRoute: typeof AppPlatformUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/a4-shop/$id': {
      id: '/_app/accounting/a4-shop/$id'
      path: '/accounting/a4-shop/$id'
      fullPath: '/accounting/a4-shop/$id'
      preLoaderRoute: typeof AppAccountingA4ShopIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/a4/$id': {
      id: '/_app/accounting/a4/$id'
      path: '/accounting/a4/$id'
      fullPath: '/accounting/a4/$id'
      preLoaderRoute: typeof AppAccountingA4IdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/credit-notes/': {
      id: '/_app/accounting/credit-notes/'
      path: '/accounting/credit-notes'
      fullPath: '/accounting/credit-notes/'
      preLoaderRoute: typeof AppAccountingCreditNotesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/credit-notes/$id': {
      id: '/_app/accounting/credit-notes/$id'
      path: '/accounting/credit-notes/$id'
      fullPath: '/accounting/credit-notes/$id'
      preLoaderRoute: typeof AppAccountingCreditNotesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/credit-notes/new': {
      id: '/_app/accounting/credit-notes/new'
      path: '/accounting/credit-notes/new'
      fullPath: '/accounting/credit-notes/new'
      preLoaderRoute: typeof AppAccountingCreditNotesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/expenses/': {
      id: '/_app/accounting/expenses/'
      path: '/accounting/expenses'
      fullPath: '/accounting/expenses/'
      preLoaderRoute: typeof AppAccountingExpensesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/expenses/$id': {
      id: '/_app/accounting/expenses/$id'
      path: '/accounting/expenses/$id'
      fullPath: '/accounting/expenses/$id'
      preLoaderRoute: typeof AppAccountingExpensesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/expenses/new': {
      id: '/_app/accounting/expenses/new'
      path: '/accounting/expenses/new'
      fullPath: '/accounting/expenses/new'
      preLoaderRoute: typeof AppAccountingExpensesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/invoices/': {
      id: '/_app/accounting/invoices/'
      path: '/accounting/invoices'
      fullPath: '/accounting/invoices/'
      preLoaderRoute: typeof AppAccountingInvoicesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/invoices/$id': {
      id: '/_app/accounting/invoices/$id'
      path: '/accounting/invoices/$id'
      fullPath: '/accounting/invoices/$id'
      preLoaderRoute: typeof AppAccountingInvoicesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/invoices/new': {
      id: '/_app/accounting/invoices/new'
      path: '/accounting/invoices/new'
      fullPath: '/accounting/invoices/new'
      preLoaderRoute: typeof AppAccountingInvoicesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/quotations/': {
      id: '/_app/accounting/quotations/'
      path: '/accounting/quotations'
      fullPath: '/accounting/quotations/'
      preLoaderRoute: typeof AppAccountingQuotationsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/quotations/$id': {
      id: '/_app/accounting/quotations/$id'
      path: '/accounting/quotations/$id'
      fullPath: '/accounting/quotations/$id'
      preLoaderRoute: typeof AppAccountingQuotationsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/quotations/new': {
      id: '/_app/accounting/quotations/new'
      path: '/accounting/quotations/new'
      fullPath: '/accounting/quotations/new'
      preLoaderRoute: typeof AppAccountingQuotationsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/receipts/': {
      id: '/_app/accounting/receipts/'
      path: '/accounting/receipts'
      fullPath: '/accounting/receipts/'
      preLoaderRoute: typeof AppAccountingReceiptsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/receipts/$id': {
      id: '/_app/accounting/receipts/$id'
      path: '/accounting/receipts/$id'
      fullPath: '/accounting/receipts/$id'
      preLoaderRoute: typeof AppAccountingReceiptsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/receipts/new': {
      id: '/_app/accounting/receipts/new'
      path: '/accounting/receipts/new'
      fullPath: '/accounting/receipts/new'
      preLoaderRoute: typeof AppAccountingReceiptsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/a4/$id': {
      id: '/_app/platform/a4/$id'
      path: '/platform/a4/$id'
      fullPath: '/platform/a4/$id'
      preLoaderRoute: typeof AppPlatformA4IdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/audits/': {
      id: '/_app/platform/audits/'
      path: '/platform/audits'
      fullPath: '/platform/audits/'
      preLoaderRoute: typeof AppPlatformAuditsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/audits/$id': {
      id: '/_app/platform/audits/$id'
      path: '/platform/audits/$id'
      fullPath: '/platform/audits/$id'
      preLoaderRoute: typeof AppPlatformAuditsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/engagements/': {
      id: '/_app/platform/engagements/'
      path: '/platform/engagements'
      fullPath: '/platform/engagements/'
      preLoaderRoute: typeof AppPlatformEngagementsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/engagements/$id': {
      id: '/_app/platform/engagements/$id'
      path: '/platform/engagements/$id'
      fullPath: '/platform/engagements/$id'
      preLoaderRoute: typeof AppPlatformEngagementsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/tenants/': {
      id: '/_app/platform/tenants/'
      path: '/platform/tenants'
      fullPath: '/platform/tenants/'
      preLoaderRoute: typeof AppPlatformTenantsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/tenants/$id': {
      id: '/_app/platform/tenants/$id'
      path: '/platform/tenants/$id'
      fullPath: '/platform/tenants/$id'
      preLoaderRoute: typeof AppPlatformTenantsIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppLeadsRoute: typeof AppLeadsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAccountSecurityRoute: typeof AppAccountSecurityRoute
  AppAccountingContactsRoute: typeof AppAccountingContactsRoute
  AppAccountingProductsRoute: typeof AppAccountingProductsRoute
  AppAccountingReportsRoute: typeof AppAccountingReportsRoute
  AppAccountingSettingsRoute: typeof AppAccountingSettingsRoute
  AppPlatformAdsRoute: typeof AppPlatformAdsRoute
  AppPlatformAiDemoRoute: typeof AppPlatformAiDemoRoute
  AppPlatformInvoicesRoute: typeof AppPlatformInvoicesRoute
  AppPlatformLeadsRoute: typeof AppPlatformLeadsRoute
  AppPlatformOnboardingRoute: typeof AppPlatformOnboardingRoute
  AppPlatformPageInboxRoute: typeof AppPlatformPageInboxRoute
  AppPlatformPlansRoute: typeof AppPlatformPlansRoute
  AppPlatformRevenueRoute: typeof AppPlatformRevenueRoute
  AppPlatformSalesRoute: typeof AppPlatformSalesRoute
  AppPlatformSupportCasesRoute: typeof AppPlatformSupportCasesRoute
  AppPlatformTeamRoute: typeof AppPlatformTeamRoute
  AppPlatformUsageRoute: typeof AppPlatformUsageRoute
  AppPlatformUsersRoute: typeof AppPlatformUsersRoute
  AppAccountingIndexRoute: typeof AppAccountingIndexRoute
  AppPlatformIndexRoute: typeof AppPlatformIndexRoute
  AppAccountingA4ShopIdRoute: typeof AppAccountingA4ShopIdRoute
  AppAccountingA4IdRoute: typeof AppAccountingA4IdRoute
  AppAccountingCreditNotesIdRoute: typeof AppAccountingCreditNotesIdRoute
  AppAccountingCreditNotesNewRoute: typeof AppAccountingCreditNotesNewRoute
  AppAccountingExpensesIdRoute: typeof AppAccountingExpensesIdRoute
  AppAccountingExpensesNewRoute: typeof AppAccountingExpensesNewRoute
  AppAccountingInvoicesIdRoute: typeof AppAccountingInvoicesIdRoute
  AppAccountingInvoicesNewRoute: typeof AppAccountingInvoicesNewRoute
  AppAccountingQuotationsIdRoute: typeof AppAccountingQuotationsIdRoute
  AppAccountingQuotationsNewRoute: typeof AppAccountingQuotationsNewRoute
  AppAccountingReceiptsIdRoute: typeof AppAccountingReceiptsIdRoute
  AppAccountingReceiptsNewRoute: typeof AppAccountingReceiptsNewRoute
  AppPlatformA4IdRoute: typeof AppPlatformA4IdRoute
  AppPlatformAuditsIdRoute: typeof AppPlatformAuditsIdRoute
  AppPlatformEngagementsIdRoute: typeof AppPlatformEngagementsIdRoute
  AppPlatformTenantsIdRoute: typeof AppPlatformTenantsIdRoute
  AppAccountingCreditNotesIndexRoute: typeof AppAccountingCreditNotesIndexRoute
  AppAccountingExpensesIndexRoute: typeof AppAccountingExpensesIndexRoute
  AppAccountingInvoicesIndexRoute: typeof AppAccountingInvoicesIndexRoute
  AppAccountingQuotationsIndexRoute: typeof AppAccountingQuotationsIndexRoute
  AppAccountingReceiptsIndexRoute: typeof AppAccountingReceiptsIndexRoute
  AppPlatformAuditsIndexRoute: typeof AppPlatformAuditsIndexRoute
  AppPlatformEngagementsIndexRoute: typeof AppPlatformEngagementsIndexRoute
  AppPlatformTenantsIndexRoute: typeof AppPlatformTenantsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppLeadsRoute: AppLeadsRoute,
  AppIndexRoute: AppIndexRoute,
  AppAccountSecurityRoute: AppAccountSecurityRoute,
  AppAccountingContactsRoute: AppAccountingContactsRoute,
  AppAccountingProductsRoute: AppAccountingProductsRoute,
  AppAccountingReportsRoute: AppAccountingReportsRoute,
  AppAccountingSettingsRoute: AppAccountingSettingsRoute,
  AppPlatformAdsRoute: AppPlatformAdsRoute,
  AppPlatformAiDemoRoute: AppPlatformAiDemoRoute,
  AppPlatformInvoicesRoute: AppPlatformInvoicesRoute,
  AppPlatformLeadsRoute: AppPlatformLeadsRoute,
  AppPlatformOnboardingRoute: AppPlatformOnboardingRoute,
  AppPlatformPageInboxRoute: AppPlatformPageInboxRoute,
  AppPlatformPlansRoute: AppPlatformPlansRoute,
  AppPlatformRevenueRoute: AppPlatformRevenueRoute,
  AppPlatformSalesRoute: AppPlatformSalesRoute,
  AppPlatformSupportCasesRoute: AppPlatformSupportCasesRoute,
  AppPlatformTeamRoute: AppPlatformTeamRoute,
  AppPlatformUsageRoute: AppPlatformUsageRoute,
  AppPlatformUsersRoute: AppPlatformUsersRoute,
  AppAccountingIndexRoute: AppAccountingIndexRoute,
  AppPlatformIndexRoute: AppPlatformIndexRoute,
  AppAccountingA4ShopIdRoute: AppAccountingA4ShopIdRoute,
  AppAccountingA4IdRoute: AppAccountingA4IdRoute,
  AppAccountingCreditNotesIdRoute: AppAccountingCreditNotesIdRoute,
  AppAccountingCreditNotesNewRoute: AppAccountingCreditNotesNewRoute,
  AppAccountingExpensesIdRoute: AppAccountingExpensesIdRoute,
  AppAccountingExpensesNewRoute: AppAccountingExpensesNewRoute,
  AppAccountingInvoicesIdRoute: AppAccountingInvoicesIdRoute,
  AppAccountingInvoicesNewRoute: AppAccountingInvoicesNewRoute,
  AppAccountingQuotationsIdRoute: AppAccountingQuotationsIdRoute,
  AppAccountingQuotationsNewRoute: AppAccountingQuotationsNewRoute,
  AppAccountingReceiptsIdRoute: AppAccountingReceiptsIdRoute,
  AppAccountingReceiptsNewRoute: AppAccountingReceiptsNewRoute,
  AppPlatformA4IdRoute: AppPlatformA4IdRoute,
  AppPlatformAuditsIdRoute: AppPlatformAuditsIdRoute,
  AppPlatformEngagementsIdRoute: AppPlatformEngagementsIdRoute,
  AppPlatformTenantsIdRoute: AppPlatformTenantsIdRoute,
  AppAccountingCreditNotesIndexRoute: AppAccountingCreditNotesIndexRoute,
  AppAccountingExpensesIndexRoute: AppAccountingExpensesIndexRoute,
  AppAccountingInvoicesIndexRoute: AppAccountingInvoicesIndexRoute,
  AppAccountingQuotationsIndexRoute: AppAccountingQuotationsIndexRoute,
  AppAccountingReceiptsIndexRoute: AppAccountingReceiptsIndexRoute,
  AppPlatformAuditsIndexRoute: AppPlatformAuditsIndexRoute,
  AppPlatformEngagementsIndexRoute: AppPlatformEngagementsIndexRoute,
  AppPlatformTenantsIndexRoute: AppPlatformTenantsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  NoAccessRoute: NoAccessRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
